import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes";
import { OrderInstlalmentsReportList } from "../../common/types/OrderInstlalmentsReportList";

export const getOrderInstallmentsReport = createAsyncThunk(
    "/OrderInstallmentsReport/detail",
    async (parameters: any, { rejectWithValue }) => {
        try {
            const method = "/OrderInstallmentsReport/detail";

            const { data, errorMessage, isSuccess } = await commonNetwork.get(method, parameters);

            if (isSuccess) {
                return data;
            } else {
                return rejectWithValue(errorMessage);
            }
        }
        catch (error: any) {
            return rejectWithValue(error.data.message);
        }
    }
);

export interface orderInstallmentsReportStateType extends FetchResultType {
    orderInstallmentsReport: OrderInstlalmentsReportList[]
}

export const orderInstallmentsReportSlice = createSlice({
    name: "orderInstallmentsReport",
    initialState: {
        orderInstallmentsReport: [],
        isfirmAvailable: true,
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: "",
        isFetchComplete: false
    },
    reducers: {
        clearState: (state) => {
            state.orderInstallmentsReport = [];
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = false;
            state.isFetchComplete = false;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getOrderInstallmentsReport.fulfilled, (state, { payload }) => {
            state.orderInstallmentsReport = payload;
            state.isFetching = false;
            state.isSuccess = true;
            state.isError = false;
            state.isFetchComplete = true;
            return state;
        });
        builder.addCase(getOrderInstallmentsReport.rejected, (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload as string;
            state.isFetchComplete = true;
            return state;
        });
        builder.addCase(getOrderInstallmentsReport.pending, (state) => {
            state.isFetching = true;
            return state;
        });
    }
}); 

export const { clearState } = orderInstallmentsReportSlice.actions;
export const orderInstallmentsReportSelector = (state: any) => state.orderInstallmentsReport;
export const orderInstallmentsReportReducer = orderInstallmentsReportSlice.reducer;